// Imagem padrão "sem imagem" — arquivo no servidor (uploads/carousel/01.png)
export const PLACEHOLDER_IMAGE = '/uploads/carousel/01.png';

// Helper para gerar URLs de imagens
export const getImageUrl = (imagePath) => {
  if (!imagePath) {
    imagePath = PLACEHOLDER_IMAGE;
  }

  // Se já é uma URL completa, retorna como está
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  const path = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  // Usar a mesma origem da página para a imagem aparecer no retângulo de prévia (admin e home)
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin + path;
  }
  if (process.env.NODE_ENV === 'production') {
    return `https://www.loucasporbeleza.com.br${path}`;
  }
  return `http://localhost:3005${path}`;
};

